import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import GetODS from "../../data/GetODS";
import { useProyecto } from "../../data/ProyectoContext";
import { useAuthContext } from "../../hooks/Auth";
import { useJobContext } from "../../hooks/Jobs";
import DuracionHorasSemana from "../Duracion/DuracionHorasSemana";
import DuracionSemanas from "../Duracion/DuracionSemanas";
import TabsObjetivos from "../TabPanel/TabsObjetivos";
import { useActividadesContext } from "../UmmIACategories/Hook/useActividades";
import HeaderApps from "../UmmIACategories/Layout/HeaderApps";
import UnidadTematicaCardImg from "../UmmIApps/Cards/ClaseActivaCardImg.png";
import AdaptacionesCurricularesABP from "./Fields/AdaptacionesCurricularesABP";
import CompetenciasSigloXXI from "./Fields/CompetenciasSigloXXI";
import Contexto from "./Fields/Contexto";
import HabilidadesSocioemocionales from "./Fields/HabilidadesSocioemocionales";
import ProjectName from "./Fields/Nombre";
import Problematica from "./Fields/Problematica";
import NameHelp from "./Indications/NameHelp";
import ObjetivesHelp from "./Indications/ObjetivesHelp";
import { Ods } from "../../interfaces/Proyecto/iProyecto";
import { FormattedAsignatura } from "../../interfaces/ObjetivosAprendizaje/iAsignaturas";
import NotEnoughCredits from "../UmmIApps/NotEnoughCredits";
import { isSendButtonDisabled } from "../../config/sendButtonRules";

// **** ETAPA = 0 ****

export default function FormProyect({
  onNextStep,
}: {
  onNextStep: () => void;
}) {
  const [openNameTypeHelp, setOpenNameTypeHelp] = useState(false);
  const [openObjetivesHelp, setOpenObjetivesHelp] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const ref = useRef<HTMLElement | null>(null);
  const { proyecto, enviarPropuestaInicialUsuario, setProyecto } =
    useProyecto();
  const [mostrarCamposAvanzados, setMostrarCamposAvanzados] = useState(false);

  const [selectedAsignatura, setSelectedAsignatura] =
    useState<FormattedAsignatura | null>(null);

  //Funciones para mostrar los campos avanzados
  const toggleCamposAvanzados = () => {
    setMostrarCamposAvanzados(!mostrarCamposAvanzados);
  };

  // Funciones para manejar la apertura y cierre de los modales de ayuda
  const handleOpen = () => setOpenNameTypeHelp(true);
  const handleClose = () => setOpenNameTypeHelp(false);

  const handleOpenObjetivesHelp = () => setOpenObjetivesHelp(true);
  const handleCloseObjetivesHelp = () => setOpenObjetivesHelp(false);

  const { isCompleted, wsProject, etapa, tipoEstructura, userId } =
    useJobContext();

  const { user } = useAuthContext();

   const {
    nivelId,
    setNivelId,
    objetivosSeleccionados,
    promptData,
    setObjetivosSeleccionados,
    setPromptData,
    setIsOAAdded,
    isOAAdded,
    setIsPersist,
    handleNivelChangeABP,
    setPersistenciaHabilitada,
    handleAsignaturaChangeLocalABP,
    setIsNotEnoughOpen,
    selectedApp
  } = useActividadesContext();

  useEffect(() => {
  //  Desactiva persistencia antes de cualquier render
  setPersistenciaHabilitada(false);
  setIsPersist(false);

  // Limpia estados relacionados con selección
  setPromptData({});
  setNivelId(null);
  setObjetivosSeleccionados({});
  setProyecto((prev) => ({
    ...prev,
    nivel_curso: "",
    materias: [],
    objetivos_aprendizaje: [],
  }));
  setIsOAAdded(false);
}, []); //  Solo se ejecuta al montar FormProyect

//Condicionamiento para botón
    const isButtonDisabled = isSendButtonDisabled("abp_beta", { proyecto });

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        expanded &&
        ref.current &&
        !ref.current.contains(event.target as Node)
      ) {
        setExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [expanded]);

  const handleODSChange = (ods: Ods) => {
    // Verifica si el ODS tiene un nombre válido
    if (ods && ods.nombre) {
      // Verifica si el ODS ya está presente en el array del estado del proyecto
      if (!proyecto.ods.some((selectedODS) => selectedODS.id === ods.id)) {
        // Agrega el objeto ODS al array en el estado del proyecto
        setProyecto((prevProyecto) => ({
          ...prevProyecto,
          ods: [...prevProyecto.ods, { id: ods.id, nombre: ods.nombre }],
        }));
      }
    }
  };

  //Escuchamos los eventos emitidos desde el servidor y esperamos la respuesta
  useEffect(() => {
    const resp = () => {
      if (
        wsProject &&
        Object.keys(wsProject).length != 0 &&
        etapa === 0 &&
        isCompleted
      ) {
        onNextStep();
      }
    };
    resp();
  }, [wsProject, etapa, isCompleted]);

  //******Manejando el envío de la prouesta seleccionada del usuario al servidor
  const handleSendInfo = async () => {
  if (!user || !selectedApp) return;

  const ummiappId = selectedApp.id_componente;
  const ummiappName = selectedApp.nombre;

 const { usuario, ...restoProyecto } = proyecto;
  const { roles, categories, ummiapps, ...usuarioSinCampos } = user || {};

  const proyectoActualizado = {
    ...restoProyecto,
    usuario: usuarioSinCampos,
    ummiappId,
    ummiappName,
  };

  console.log("Proyecto actualizado:", proyectoActualizado);
  window.scrollTo({ top: 0, behavior: "smooth" });

  if (user.creditosDisponibles < selectedApp.valor_creditos) {
    setIsNotEnoughOpen(true);
  } else {
    // Enviar con los datos actualizados
    enviarPropuestaInicialUsuario(proyectoActualizado, "crear_proyecto");
  }
};
 


  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/asistente/ummiaplan");
  };


  
  return (
    <>
      <HeaderApps
        imageSrc={UnidadTematicaCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #A9D1C0 100%, #52A381 100%)"
        }
        titleColor="#278C62"
        title="Planificación ABP"
        description="Diseña proyectos de Aprendizaje Basado en Problemas (ABP) de manera
        eficiente con UmmIA."
        onBack={handleBack}
        colorIconBack={"#52A381"}
      />
      {/*Formulario*/}
      {/*Contenedor principal del formulario */}{" "}
      <Grid container>
        {/*Contenedor para objetivos */}
        <>
          <Grid>
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontSize: "1.25rem",
                fontWeight: "bold",
                color: "#1D3D4D",
              }}
            >
              ¿Qué objetivos de aprendizaje quieres trabajar?{" "}
              <Button
                sx={{ color: "#1D3D4D" }}
                onClick={handleOpenObjetivesHelp}
              >
                <HelpOutlineIcon />
              </Button>
            </Typography>
          </Grid>
          {/*Modal sección Objetivos*/}{" "}
          <ObjetivesHelp
            open={openObjetivesHelp}
            onClose={handleCloseObjetivesHelp}
          />
          <Grid item xs={12} lg={12} display="flex" flexDirection="row">
            <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mb: 4, mt: 3 }}>
              <GetNiveles
                onNivelChange={handleNivelChangeABP}
                selectedNivel={nivelId}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={12}
              sx={{ mb: 4, mt: 3, ml: 3 }}
            >
              <GetAsignaturas
                nivelId={nivelId}
                onAsignaturaChange={(asignatura: FormattedAsignatura) => {
                  setSelectedAsignatura(asignatura);
                  handleAsignaturaChangeLocalABP(asignatura);
                }}
                selectedAsignatura={
                  selectedAsignatura ? selectedAsignatura.id : ""
                }
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TabsObjetivos
              nombreNivel={promptData.nivel}
              asignaturaSeleccionada={selectedAsignatura} 
              setPromptData={setPromptData}
              objetivosSeleccionados={objetivosSeleccionados}
              setObjetivosSeleccionados={setObjetivosSeleccionados}
              setIsOAAdded={setIsOAAdded}
            />
          </Grid>
        </>

        {/*Contenedor para tema del proyecto, duración y tipo de la clase */}
        <>
          <Typography
            sx={{
              fontFamily: "montserrat",
              fontSize: "1.25rem",
              fontWeight: "bold",
              color: "#1D3D4D",
            }}
          >
            Tema y duración de la clase{" "}
            <Button sx={{ color: "#1D3D4D" }} onClick={handleOpen}>
              <HelpOutlineIcon />
            </Button>
          </Typography>
          {/*Modal sección Nombre y tipo de proyecto*/}{" "}
          <NameHelp open={openNameTypeHelp} onClose={handleClose} />
          {/*Campo nombre de proyecto */}
          <ProjectName />
          {/*Campos de duración semanal y horaria */}
          <Grid container spacing={2}>
            {" "}
            <Grid item xs={12} md={6}>
              {" "}
              <DuracionSemanas />
            </Grid>
            <Grid item xs={12} md={6}>
              {" "}
              <DuracionHorasSemana />
            </Grid>
          </Grid>
        </>

        {/*Contenedor para configuraciones de proyecto */}
        <>
          <Grid
            item
            xs={12}
            container
            justifyContent="center"
            sx={{ mb: 3, mt: 5 }}
          >
            <Button
              variant="text"
              sx={{ color: "#336B87", fontFamily: "montserrat" }}
              onClick={toggleCamposAvanzados}
              endIcon={
                mostrarCamposAvanzados ? <ExpandMoreIcon /> : <ExpandMoreIcon />
              }
            >
              {mostrarCamposAvanzados
                ? "Ocultar opciones avanzadas"
                : "Mostrar opciones avanzadas (opcional)"}
            </Button>
          </Grid>

          {/* Campos avanzados */}
          {mostrarCamposAvanzados && (
            <>
              {/*Acordeon para agregar indicaciones y conceptos clave */}{" "}
              <Grid item xs={12}>
                <Problematica />

                <Contexto />

                <AdaptacionesCurricularesABP />

                <HabilidadesSocioemocionales />

                <CompetenciasSigloXXI />
              </Grid>
              {/* Campo de selección para un ODS*/}
              <GetODS onODSChange={handleODSChange} />
            </>
          )}
        </>
      </Grid>
      {/*Botón para enviar la información*/}
      <Button
        variant="contained"
        onClick={handleSendInfo}
        disabled ={isButtonDisabled}
        data-amplify-analytics-on="click"
        data-amplify-analytics-name={`click-on-ummia-proponme-ideas`}
        data-amplify-analytics-attrs={`onClick:handleSendInfo, userId:${userId}, tipoEstructura:${tipoEstructura}, etapa:${etapa}`}
        sx={{
          borderRadius: 5,
          m: "auto",
          width: "60%",
          alignContent: "center",
          backgroundColor: "#1FC16B",
          "&:hover": {
            backgroundColor: "#34C759",
          },
          fontFamily: "montserrat",
          fontWeight: "bold",
        }}
      >
        ¡UMMIA, proponme ideas geniales!
      </Button>
      {/* Popup en caso de que se excedan créditos */}
      <NotEnoughCredits />
    </>
  );
}
